require('../../modules/es.string.from-code-point');
var path = require('../../internals/path');

module.exports = path.String.fromCodePoint;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/string/from-code-point.js
// module id = 1228
// module chunks = 1